import { use } from "react";
import type { GamePageContext } from "../game-types";
import { GameContext } from "./game-context";

export function useGameContext(): GamePageContext {
  const game = use(GameContext);

  if (!game) throw new Error("Game pages require an admitted game route");

  return game;
}
